import { motion } from "framer-motion";
import { Box, Card, CardContent, TextField, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import Stack from '@mui/material/Stack';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import React from "react";
import NPSInput from "./NPSInput";
import classNames from 'classnames';
import './NPSInput.css';
import './NPSScale.css';
import { Encuesta } from "@/api/encuestaService";
import { encuestaService } from "api/encuestaService";
import AnnouncementIcon from '@mui/icons-material/Announcement';



export default function EncuestaComponent() {
    const [alignment, setAlignment] = React.useState('left');
    const [hoveredValue, setHoveredValue] = React.useState<number | null>(null);
    const [encuesta, setEncuesta] = React.useState<Encuesta[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [openAnswered, setOpenAnswered] = React.useState(false);
    const [openSent, setOpenSent] = React.useState(false);
    const [openValidate, setOpenValidate] = React.useState(false);

    React.useEffect(() => {
        const fetchEncuesta = async () => {
            try {
                setLoading(true);
                const e = await encuestaService.get();
                console.log("encuesta:" + JSON.stringify(e))
                setEncuesta(e);
                if (e[0].id) {
                    console.log("respondida");
                    setOpenAnswered(true);
                } else {
                    console.log("no respondida");
                }
            } catch (error) {
                console.error("Error al obtener encuesta:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchEncuesta();

    }, []);

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        //setAlignment(newAlignment);
    };


    const control = {
        value: alignment,
        onChange: handleChange,
        exclusive:
            true,
    };



    const handleCloseOpenAnswered = () => {
        setOpenAnswered(false);
    }
    const handleCloseOpenSent = () => {
        setOpenSent(false);
    }
    const handleCloseOpenValidate = () => {
        setOpenValidate(false);
    }

    const validate = () => {
        console.log(JSON.stringify(encuesta));

        for (let i = 0; i < encuesta.length; i++) {
            const item = encuesta[i];
            if (item.type === 'score') {
                if (item.score === null || item.score === undefined || item.score < 0) {
                    console.log(`Score inválido en índice ${i}`);
                    return false;
                }
            } else {
                if (!item.comment || item.comment.trim() === '') {
                    console.log(`Comentario vacío en índice ${i}`);
                    return false;
                }
            }
        }

        return true;
    };


    const onSubmit = async () => {
        if (loading) {
            return;
        }
        if (!validate()) {
            setOpenValidate(true);
            return;
        }
        setLoading(true);
        try {
            const save = await encuestaService.save(encuesta);
            setOpenSent(true);
            console.log(JSON.stringify(save));
            if(save.survey){
                setEncuesta(save.survey);
            }
        } catch (error) {
            alert('Hubo un problema al enviar la encuesta. Por favor reintenta denuevo más tarde.');
            console.error("Error al enviar encuesta", error);
        } finally {
            setLoading(false);
        }
    }

    const range = (start: number, end: number): number[] => {
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    };

    const handleMouseEnter = (value: number) => {
        setHoveredValue(value);
    };

    const handleMouseLeave = () => {
        setHoveredValue(null);
    };

    const handleSelect = (value: number) => {
        onSubmit();
    };

    return (
        <div className="containerMultipleChoiceTabs">

            {encuesta ?

                <motion.div
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3 }}
                    className="mxAuto"
                >
                    <div className="mxAuto">
                        <Card className="cardClass">
                            <CardContent>
                                <div className="title">Encuesta de satisfacción</div>
                            </CardContent>
                            <CardContent>

                                <Box className="home-component" >
                                    <Stack spacing={2} sx={{ alignItems: 'center' }}>
                                        {
                                            encuesta.map((pregunta, index) => (
                                                <div>
                                                    <div className="NPStitleQuestion">{index + 1} - {pregunta.question}</div>
                                                    {
                                                        pregunta.type === 'score' ?

                                                            <div className="NPSInput-Inner">
                                                                <Box sx={{ width: 781, backgroundColor: "white" }}>
                                                                    <div className="NPSScale" >

                                                                        <div className="NPSScale-Values">

                                                                            {range(1, 5).map((i) => (
                                                                                <div
                                                                                    key={i}
                                                                                    className={classNames('NPSScale-Value', {/*
                                                                            'NPSScale-Value-6': i < 7,
                                                                            'NPSScale-Value-8': i >= 7 && i < 9,
                                                                            'NPSScale-Value-10': i >= 9,*/
                                                                                        'NPSScale-Value-selected': i == pregunta.score,
                                                                                    })}
                                                                                    //onMouseEnter={() => handleMouseEnter(i)}
                                                                                    //onMouseLeave={handleMouseLeave}
                                                                                    onClick={() => {
                                                                                        const nuevaEncuesta = [...encuesta]; // Clonamos el array
                                                                                        nuevaEncuesta[index] = {
                                                                                            ...nuevaEncuesta[index],        // Clonamos el objeto actual
                                                                                            score: i                        // Actualizamos el score
                                                                                        };
                                                                                        setEncuesta(nuevaEncuesta);       // Guardamos el nuevo estado
                                                                                    }}
                                                                                >
                                                                                    <div>{i}</div>
                                                                                </div>
                                                                            ))}


                                                                        </div>
                                                                        <div className="NPSScale-Legend">
                                                                            <div className="NPSScale-Label left">Totalmente<br />en desacuerdo</div>
                                                                            <div className="NPSScale-Label right">Totalmente<br />de acuerdo</div>
                                                                        </div>
                                                                    </div>
                                                                </Box>
                                                            </div>
                                                            :
                                                            <div className="NPSInput-Inner">
                                                                <Box sx={{ width: 781, backgroundColor: "white" }}>
                                                                    <div className="NPSScale" >

                                                                        <TextField value={pregunta.comment}
                                                                            onChange={(e) => {
                                                                                const nuevaEncuesta = [...encuesta]; // Clonamos el array
                                                                                nuevaEncuesta[index] = {
                                                                                    ...nuevaEncuesta[index],          // Clonamos el objeto actual
                                                                                    comment: e.target.value           // Actualizamos el comentario
                                                                                };
                                                                                setEncuesta(nuevaEncuesta);         // Actualizamos el estado
                                                                            }}
                                                                            required fullWidth type="text" label="Añade un comentario para complementar tu reseña" sx={{ mb: 1 }} multiline rows={2}
                                                                            inputProps={{ maxLength: 1000 }} />

                                                                    </div>
                                                                </Box>
                                                            </div>
                                                    }


                                                </div>
                                            ))
                                        }
                                        <div className="submitButtonContainer">
                                            <Button type="submit" onClick={onSubmit} variant="contained" color="primary" >{loading ? <CircularProgress size={24} color="inherit" /> : "Enviar"}</Button>
                                        </div>
                                    </Stack>
                                </Box>


                            </CardContent>
                        </Card>
                    </div>
                </motion.div>
                : <>Cargado...</>}


            <Dialog open={openAnswered} onClose={handleCloseOpenAnswered}>
                <DialogTitle><AnnouncementIcon /> Atención</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Esta encuesta ya la respondiste. Si deseas actualizar tu respuesta, modifica el formulario y envíalo nuevamente.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseOpenAnswered} color="secondary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openSent} onClose={handleCloseOpenSent}>
                <DialogTitle><AnnouncementIcon /> Atención</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Encuesta enviada. Muchas gracias por tu respuesta, ésta nos ayudará a mejorar.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseOpenSent} color="secondary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openValidate} onClose={handleCloseOpenValidate}>
                <DialogTitle><AnnouncementIcon /> Atención</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Debes escoger un valor en la escala y agregar un comentario para poder enviar.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseOpenValidate} color="secondary">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}